import React from "react";
import { handleUserSession } from "../../../../../utils";
import { showTextTruncateWarning } from "../PaginatedDownloadCsv";
import DataExporterButton from "./DataExporterButton";
import DataExporterProgress from "./DataExporterProgress";
import useDataExport from "./useDataExport";
import { DEFAULT_BUTTON_CONFIGS, DEFAULT_ITEMS_PER_PAGE } from "./constants";

function DataExporter({
  buttonConfigs = DEFAULT_BUTTON_CONFIGS,
  fetchFn,
  fileName,
  filterParams,
  isDisabled,
  itemsPerPage = DEFAULT_ITEMS_PER_PAGE,
  onError,
  onTruncate = showTextTruncateWarning,
  tooltipText,
  totalItems,
  transforms,
}) {
  const { isExporting, progressPercent, startExport } = useDataExport({
    buttonConfigs,
    fetchFn,
    fileName,
    filterParams,
    itemsPerPage,
    onError,
    onTruncate,
    totalItems,
    transforms,
  });

  return (
    <div className="paginated-csv" data-testid="paginated-csv">
      <DataExporterProgress
        inProgress={isExporting}
        progressPercent={progressPercent}
      />
      <DataExporterButton
        buttonLabels={Object.keys(buttonConfigs)}
        id="paginatedCsv"
        isBusy={isExporting}
        isDisabled={isDisabled}
        onButtonClick={(buttonText) => {
          handleUserSession(true);
          startExport(buttonText);
        }}
        tooltipText={tooltipText}
      />
    </div>
  );
}

export default DataExporter;
